import moment from "moment";
import { ucEndpoints } from "../../config/config";
import { AppDispatch, RootState } from "../../reducers";
import {
  getDateFormatsFailure,
  getDateFormatsSuccess,
  getTimeFormatsFailure,
  getTimeFormatsSuccess,
  startGetDateFormats,
  startGetTimeFormats
} from "../../store/dateTimeFormats";
import { apiCallBegan } from "../middlwares/api";

export const getDateFormats = () => (dispatch: AppDispatch) => {
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.dateFormats}`,
      method: "get",
      onStart: startGetDateFormats,
      onSuccess: getDateFormatsSuccess,
      onFailure: getDateFormatsFailure
    })
  );
};

export const getTimeFormats = () => (dispatch: AppDispatch) => {
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.timeFormats}`,
      method: "get",
      onStart: startGetTimeFormats,
      onSuccess: getTimeFormatsSuccess,
      onFailure: getTimeFormatsFailure
    })
  );
};

export const formatDateAsShortDate = (date: string | Date) => (
  dispatch: AppDispatch,
  getState: () => RootState
) => {
  const { regionSettings, regionSettingsPerUser } = getState();

  return moment(date).format(
    regionSettingsPerUser.shortDateFormat?.format ??
      regionSettings.shortDateFormat?.format ??
      "M/D/YYYY"
  );
};
